import React from 'react';

/**
 * Skeleton placeholder row — same height as a real EpisodeRow.
 * CSS shimmer animation prevents layout shift when real rows arrive.
 *
 * @param {Object} props
 * @param {number} [props.titleWidth] - Percentage width of the title placeholder (default 55)
 */
export default function SkeletonRow({ titleWidth = 55 }) {
  return (
    <div className="skeleton-row" aria-hidden="true">
      <div
        className="skeleton skeleton-row__title"
        style={{ width: `${titleWidth}%` }}
      />
      <div className="skeleton skeleton-row__bar" />
    </div>
  );
}

/**
 * Renders N skeleton rows inside the episode-list container.
 */
export function SkeletonList({ count = 6 }) {
  const widths = [55, 70, 45, 65, 50, 75];
  return (
    <div className="episode-list" aria-busy="true" aria-label="Loading episodes">
      {Array.from({ length: count }, (_, i) => (
        <SkeletonRow key={i} titleWidth={widths[i % widths.length]} />
      ))}
    </div>
  );
}
